<template>
  <div class="modal-product-order-performance-container">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="modal-title">상품 주문/전환 퍼포먼스 정보</div>
      <template>
        <div class="columns is-multiline">
          <div v-if="showMartPartner" class="column is-full">
            <button style="width:180px;" class="button" @click="$router.push(getPath(`mart/partner/product/detail?id=${$route.query.id}`))">파트너별 상세 현황 보기></button>
          </div>
          <div class="column is-full">
            <admin-form-item label="상품 주문/전환 종류 " :isFlex="true">{{ productType }}</admin-form-item>
          </div>
          <div class="column is-full">
            <admin-form-item label="상품 현황 " :isFlex="true">
              <div class="flex-align">
                <div :class="statusCircle" class="c-status"></div>
                {{ productSaleStatus }}
              </div>
            </admin-form-item>
          </div>
          <div class="column is-6">
            <admin-form-item label="상품 참여 퍼포먼스">
              <table>
                <tr>
                  <td style="width:25%">
                    <div class="table-title">조회수</div>
                    <div class="table-content">{{ performance.visit|currencyNum }}</div>
                  </td>
                  <td style="width:25%">
                    <div class="table-title">찜</div>
                    <div class="table-content">{{ performance.like|currencyNum }}</div>
                  </td>
                  <td style="width:25%">
                    <div class="table-title">공유</div>
                    <div class="table-content">{{ performance.share|currencyNum }}</div>
                  </td>
                  <td style="width:25%">
                    <div class="table-title">문의</div>
                    <div class="table-content">{{ performance.inquiry|currencyNum }}</div>
                  </td>
                </tr>
              </table>
            </admin-form-item>
          </div>
          <div class="column is-6" v-if="isInternalPlugin('sns_inquiry')">
            <admin-form-item label="SNS 문의 퍼포먼스">
              <table>
                <tr>
                  <td style="width:20%">
                    <div class="table-title">SNS 전체</div>
                    <div class="table-content">{{ snsTotalCount }}</div>
                  </td>
                  <td style="width:20%">
                    <div class="table-title">네이버 블로그</div>
                    <div class="table-content">{{ prod.naver_count }}</div>
                  </td>
                  <td style="width:20%">
                    <div class="table-title">카카오톡</div>
                    <div class="table-content">{{ prod.kakao_count }}</div>
                  </td>
                  <td style="width:20%">
                    <div class="table-title">인스타그램</div>
                    <div class="table-content">{{ prod.instagram_count }}</div>
                  </td>
                  <td style="width:20%">
                    <div class="table-title">홈페이지</div>
                    <div class="table-content">{{ prod.homepage_count }}</div>
                  </td>
                </tr>
              </table>
            </admin-form-item>
          </div>

          <div class="column is-6">
            <admin-form-item label="상품 주문 전환 퍼포먼스">
              <table>
                <tr>
                  <td style="padding:8px 16px">
                    <div class="flex-between">
                      <div class="table-title">{{ conversion.after.label }}</div>
                      <div class="table-content">{{ conversion.after.count }}</div>
                    </div>
                  </td>
                </tr>
              </table>
            </admin-form-item>
          </div>
          <div class="column is-6">
            <admin-form-item label="상품 바이럴 퍼포먼스">
              <table>
                <tr>
                  <td style="width:50%">
                    <div class="table-title">상품 후기</div>
                    <div class="table-content">{{ performance.review }}</div>
                  </td>
                  <td style="width:50%">
                    <div class="table-title">상품 평점</div>
                    <div class="table-content">{{ performance.pop_score }}</div>
                  </td>
                </tr>
              </table>
            </admin-form-item>
          </div>
        </div>
        <!-- <admin-box-item :disabled="disabled">
        </admin-box-item> -->
      </template>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  export default {
    name: 'ModalProductOrderPerformance',
    components: {
      SweetModal
    },
    props: {
      prod: {
        type: Object
      },
      performance: {
        type: Object
      },
      disabled: {
        type: Boolean
      },
      conversion: {
        type: Object
      },
      productType: {
        type: String
      }
    },
    methods: {
      open() {
        this.$refs.modal.open();
      },
    },
    computed: {
      productSaleStatus () {
        return this.prod.sale_status === 1 ? '품절' : this.prod.sale_status === 2 || !this.prod.enable_prod ? '판매중단' : '판매중';
      },
      statusCircle() {
        return this.prod.sale_status === 1 ? 'c-gray' : this.prod.sale_status === 2 || !this.prod.enable_prod ? 'c-primary' : 'c-green';
      },
      snsTotalCount() {
        return ['instagram', 'naver', 'kakao', 'homepage'].reduce((acc, cur) => {
          let cnt = this.prod[`${cur}_count`];
          if(!cnt) {
            cnt = 0;
          }
          return acc + cnt;
        }, 0)
      },
      showMartPartner () {
        return (this.prod.order_conversion_type===12 &&
          this.$route.query.id &&
          (this.$store.getters.mode==='admin' || this.$store.getters.mode==='supervisor'))
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-product-order-performance-container
    color #363636

  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .c-status
    width 10px
    height 10px
    border-radius 100%
    margin 0 6px 0 8px
  .c-gray
    background-color #B6BECB
  .c-primary
    background-color #FF5722
  .c-green
    background-color #75C791
  .table-title
  .table-content
    text-align center
    font-size 13px

  .table-title
    color #787878
  .table-content
    color #363636

</style>
<style lang="stylus">
  .modal-product-order-performance-container
    .sweet-modal.is-alert
      width 974px
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
